export function resolveControlsVisibility(options: {
    isBasketDerived: boolean;
    pastDueForScheduling: boolean;
    isDepositBearing: boolean;
    isItemBasedDepositBearing: boolean;
    firstTargetMinor: number | undefined;
    hasCollectionChoice: boolean;
    productOffersControls: boolean;
}): { showDepositSection: boolean; showCollectionCount: boolean; reserveControlsColumn: boolean } {
    const settled = options.isBasketDerived && !options.pastDueForScheduling;
    const showDepositSection =
        options.isDepositBearing &&
        settled &&
        !(options.isItemBasedDepositBearing && options.firstTargetMinor === undefined);
    const showCollectionCount = options.hasCollectionChoice && settled;

    return {
        showDepositSection,
        showCollectionCount,
        reserveControlsColumn:
            showDepositSection || showCollectionCount || (options.productOffersControls && settled),
    };
}
